import { css } from "@emotion/css";
import { LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import { RepeatOffIcon, RepeatOnIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens, space } from "@octopusdeploy/design-system-tokens";
import { type AnnuallyRecurringSchedule, type DailyRecurringSchedule, type MonthlyRecurringSchedule, type WeeklyRecurringSchedule, type RecurringScheduleResource } from "@octopusdeploy/octopus-server-client";
import moment from "moment";
import { ScheduleFormatter } from "~/utils/ScheduledTriggerDescriptionHelper/ScheduleFormatter";
interface DeploymentFreezeDataRecurrenCadenceCellProps {
    startDate?: string;
    recurringSchedule?: RecurringScheduleResource | DailyRecurringSchedule | WeeklyRecurringSchedule | MonthlyRecurringSchedule | AnnuallyRecurringSchedule | undefined;
}
export const DeploymentFreezeDataRecurrenCadenceCell = ({ startDate, recurringSchedule }: DeploymentFreezeDataRecurrenCadenceCellProps) => {
    const iconColor = recurringSchedule ? themeTokens.color.icon.success : themeTokens.color.icon.secondary;
    return (<LegacyDataTableRowColumn className={cellStyles}>
            <div className={innerCellStyles}>
                {recurringSchedule ? (<div>
                        <RepeatOnIcon size={24} color={iconColor}/>
                    </div>) : (<div>
                        <RepeatOffIcon size={24} color={iconColor}/>
                    </div>)}
                <div className={cadenceStyles}>{ScheduleFormatter.buildScheduleSummary(recurringSchedule, moment(startDate))}</div>
            </div>
        </LegacyDataTableRowColumn>);
};
const cadenceStyles = css({ marginLeft: space[8] });
const innerCellStyles = css({
    display: "flex",
    alignItems: "center",
});
const cellStyles = css({ width: "30%" });
